import { createAction } from 'redux-act';

import { ReservationGuest } from '../../../models/interfaces/reservation/Reservation';
import ReservationPayload from './ReservationPayload';

export interface UpdateReservationGuestPayload extends ReservationPayload {
  reservationGuest: ReservationGuest;
}
export const updateReservationGuest = createAction<UpdateReservationGuestPayload>('UPDATE_RESERVATION_GUEST');
